formatzipcode = () => {

     var input = document.getElementById('zip').value;
      var output = document.getElementById('alert');
     if ( input.length == 6 ) {
       const startDate = new Date();
        startDate.setDate(startDate.getDate() + 3);
        const endDate = new Date(startDate);
        endDate.setDate(endDate.getDate() + 4);
        const formatDate = date => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString(undefined, options);
        };
        const dateRangeText = ` Estimated Delivery Date: ${formatDate(startDate)} - ${formatDate(endDate)}`;
        document.getElementById('alert').textContent = dateRangeText;
     }
     else{
       output.innerHTML = "Wrong Pincode";
     }
    }